import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  name: {
    display: 'flex',
    alignItems: 'center',

    '& div': {
      marginLeft: '0.5rem',
      opacity: '0.35',
      fontStyle: 'italic'
    }
  },

  bold: {}
}))

export default useStyles
